module.exports = __webpack_public_path__ + "static/img/title.6efc4fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/title.png
// module id = UI9h
// module chunks = 7